import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';

import { Tooltip } from 'src/app/model/tooltip';
import { Router, ActivatedRoute } from '@angular/router';
import { CurrencyFunctionalityService } from '../../shared/utilities/functionality/currency-functionality.service';
import { ToolTipNotificationComponent } from '../../form-elements/tool-tip-notification/tool-tip-notification.component';
import { CurrencyDirective } from '../../shared/directives/currency.directive';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-currency',
    templateUrl: './currency.component.html',
    styleUrls: ['./currency.component.scss'],
    imports: [ReactiveFormsModule, NgClass, CurrencyDirective, ToolTipNotificationComponent]
})
export class CurrencyComponent {

  @Input() controllerData;
  @Input() parent: UntypedFormGroup;
  @Input() tooltipData: Tooltip = new Tooltip();
  @Input() childCurrency: string;
  @Input() controlName;
  @Input() componentName;
  @Input() source;
  @Output() currencyChangeEventEmitter: EventEmitter<string> = new EventEmitter<string>();
  @Output() currenyChildEmitter: EventEmitter<string> = new EventEmitter<string>();
  @Output() displayMobileTooltipEmitter: EventEmitter<any> = new EventEmitter<any>();

  protected value = '';
  yourPensionACE;
  constructor(public router: Router, private route: ActivatedRoute,
              private activatedRoute: ActivatedRoute) {
    this.yourPensionACE = this.activatedRoute.snapshot.data.contentData.yourPension;
  }

  currencyChangeHandler(val) {
    this.currencyChangeEventEmitter.emit(val ? val : '0');
  }

  validateInput = () => {
    this.currenyChildEmitter.emit();
  }
  invalidTaxfree = (message): string => {
    message = message.replace('[dealpartner]', (this.source ? this.source : ''));
    return message;
  }
  invalidPTFCTaxfree = (message): string => {
    message = message.replace('[dealpartner]', (this.source ? this.source : '')).replace('25%', '99.99%');
    return message;
  }
  setMinLTA = (errorMessage): string => {
    let MinValue = this.yourPensionACE.minPensionValue; 
    if(this.parent && this.parent['value'] && this.parent['value']['productType'])  { 
      MinValue = (this.parent['value']['productType'] != 'C') ?  this.yourPensionACE.GIAPensionValue : this.yourPensionACE.minPensionValue;
    }
    errorMessage = errorMessage.replace('[LTAMin]',
      CurrencyFunctionalityService.convertNumberToCurrency(MinValue));
    return errorMessage;
  }

  displayMobileTooltipSliderReceiver() {
    this.displayMobileTooltipEmitter.emit();
  }
}
